import { ProductReceiptParams, ProductReceiptsApiResponse } from '@repo/accounts-types'
import { Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export const getBankingProductLoanReceipts: Service<
  ProductReceiptParams,
  ProductReceiptsApiResponse,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  const { id, ...filters } = params

  return api.get<ProductReceiptsApiResponse>(`/accounts/loans/${id}/receipts`, {
    params: filters,
    ...config,
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
  })
}
